import type { ReactElement } from 'react';
import { Badge } from '@/components/atoms/badge';
import { masteryVisualLevel, type MasteryVisualLevel } from '@/lib/mastery';
import { cn } from '@/lib/cn';

const TONE: Readonly<Record<MasteryVisualLevel, 'neutral' | 'warn' | 'brand' | 'ok'>> = {
  new: 'neutral',
  learning: 'warn',
  solid: 'brand',
  fluent: 'ok',
};
const LABEL: Readonly<Record<MasteryVisualLevel, string>> = {
  new: 'New', learning: 'Learning', solid: 'Solid', fluent: 'Fluent',
};
const CANONICAL_TO_SORT: Readonly<Record<string, number>> = {
  not_started: 0, hard_to_sightread: 1, good_sightreading: 2,
  halfway_memorized: 3, memorized_with_articulation_dynamics: 4, performance_ready: 5,
};

export type MasteryBadgeProps = {
  sortOrder?: number | null;
  canonicalName?: string | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

export function MasteryBadge({ sortOrder, canonicalName, className, size }: MasteryBadgeProps): ReactElement {
  const effectiveSort = sortOrder ?? (canonicalName ? CANONICAL_TO_SORT[canonicalName] ?? null : null);
  const level = masteryVisualLevel(effectiveSort);
  return (
    <Badge tone={TONE[level]} size={size} className={cn(className)}>
      {LABEL[level]}
    </Badge>
  );
}
